

<footer class="site_footer">
  <div class="container">
    <div class="inner">
      <div class="col_single">
          <figure class="site_logo" [routerLink]="logoLink">
          <img [src]="assetsConst.logo" alt="Logo">
        </figure>
     
      </div>
      <div class="col_single text_white">
        <p>  <small> © 2025 Notchmark. All rights reserved.</small></p>
      </div>

      <ul class="social_icon_list">
        <li>
          <figure>
            <img src="{{assetsConst.socialIcon}}" alt="icon">
          </figure>
        </li>    
         <li>
          <figure>
            <img src="{{assetsConst.socialIcon2}}" alt="icon">
          </figure>
        </li>
               <li>
          <figure>
            <img src="{{assetsConst.socialIcon3}}" alt="icon">   
          </figure>
        </li>
            <li>
          <figure>
            <img src="{{assetsConst.socialIcon4}}" alt="icon">
          </figure>
        </li>
             <li>
          <figure>
            <img src="{{assetsConst.socialIcon5}}" alt="icon">
          </figure>
        </li>
      </ul>
  
    </div>
  </div>

</footer>
